export default "__VITE_ASSET___hfEb4GW__"